export { default } from './svg/exclamation-fill.svg';
